import { useEffect, useState } from 'react'
import {
  getPositionBottom,
  getPositionLeft,
  getPositionRight,
  getPositionTop,
} from './helpers'

export const CalculateTooltipPosition = ({
  contentRef,
  dropdownRect,
  position,
  dropdownSpace,
  setPriorityPosition,
}) => {
  // Use state
  const [bodySize, setBodySize] = useState({ height: 0, width: 0 })
  const [defaultDropdownRect, setDefaultDropdownRect] = useState()

  // Actions
  const calcBodySize = () => {
    const timeout = setTimeout(() => {
      setBodySize({
        height: document.body.offsetHeight,
        width: document.body.offsetWidth,
      })
      clearTimeout(timeout)
    }, 200)
  }

  // Use effect
  useEffect(() => {
    setBodySize({
      height: document.body.offsetHeight,
      width: document.body.offsetWidth,
    })
    window.addEventListener('resize', calcBodySize)
    return () => window.removeEventListener('resize', calcBodySize)
  }, [])

  useEffect(() => {
    if (defaultDropdownRect) return
    const interval = setInterval(() => {
      if (dropdownRect) {
        setDefaultDropdownRect(dropdownRect)
        clearInterval(interval)
      }
    }, 100)
    return () => clearInterval(interval)
  }, [dropdownRect])

  useEffect(() => {
    if (contentRef.current?.getBoundingClientRect() && defaultDropdownRect) {
      const positionTop = getPositionTop(
        contentRef,
        bodySize,
        defaultDropdownRect,
        position,
        dropdownSpace,
      )

      if (positionTop) return setPriorityPosition(positionTop)

      const positionBottom = getPositionBottom(
        contentRef,
        bodySize,
        defaultDropdownRect,
        position,
        dropdownSpace,
      )

      if (positionBottom) return setPriorityPosition(positionBottom)

      const positionLeft = getPositionLeft(
        contentRef,
        bodySize,
        defaultDropdownRect,
        position,
        dropdownSpace,
      )

      if (positionLeft) return setPriorityPosition(positionLeft)

      const positionRight = getPositionRight(
        contentRef,
        bodySize,
        defaultDropdownRect,
        position,
        dropdownSpace,
      )

      if (positionRight) return setPriorityPosition(positionRight)
    }
  }, [
    contentRef.current?.getBoundingClientRect(),
    defaultDropdownRect,
    bodySize,
  ])

  return <></>
}
